<template>
    <div class="shadow-1 bg-white">
      <q-list
        class="menu"
      >
        <q-expansion-item
          expand-separator
          v-for="(key) in Object.keys(menuComponent)"
          v-model="menuComponent[key].active"
          :label="menuComponent[key].label"
          :key="key"
          group="somegroup"
          :data-testid="'grupoPontoAcesso-'+menuComponent[key].idGrupoPontoAcesso"
        >
          <template #header>
            <q-item-section avatar>
              <div :class="getClassIcon(menuComponent[key].idGrupoPontoAcesso)"/>
            </q-item-section>

            <q-item-section>
              <h6 class="text-main-menu">
                {{ menuComponent[key].label }}
              </h6>
            </q-item-section>
          </template>

          <q-item
            v-for="(item) in menuComponent[key].list"
            :key="item.chPontoAcesso"
            :data-testid="'pontoAcesso-'+item.chPontoAcesso"
            clickable
            :active="item.active"
            @click="selectItem(item)"
            class="q-expansion-item-focus"
          >
            <q-item-section avatar>
              <q-icon :name="edit" />
            </q-item-section>
            <q-item-section> {{ item.dsPontoAcesso }} </q-item-section>
          </q-item>
        </q-expansion-item>
      </q-list>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestModel from '../ServiceRequestModel'
import ServiceRequestController from '../ServiceRequestController'

@Component({
  name: 'ServiceRequestConsumerUnitMenu',
  components: {
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestConsumerUnitMenu extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  isHover = false

  get menuComponent () {
    return this.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].menu
  }

  getClassIcon (idGrupoPontoAcesso) {
    if (idGrupoPontoAcesso == '121') {
      return 'icon-financial'
    } else if (idGrupoPontoAcesso == '122') {
      return 'icon-register'
    } else if (idGrupoPontoAcesso == '123') {
      return 'icon-service-order'
    } else if (idGrupoPontoAcesso == '124') {
      return 'icon-service'
    }
  }

  selectItem (item) {
    this.controller.routerConsumerUnit(
      {
        name: item.nmContainerJavaScript,
        params: {
          consumerUnit: this.consumerUnit,
          protocol: this.protocol
        }
      },
      this.protocol,
      this.consumerUnit
    )
  }
}
export default ServiceRequestConsumerUnitMenu
</script>
<style lang="stylus" scoped>
.q-expansion-item-focus:hover {
       background-color: #5898aa;
       color: #fff;
}

.icon-financial {
  background-image:  url("~assets/service-request/menu/financial.png");
  width: 32px; height: 32px;
  background-size: 100%;
  margin-left: 10px;
}
.icon-register {
  background-image:  url("~assets/service-request/menu/register.png");
  width: 32px; height: 32px;
  background-size: 100%;
  margin-left: 10px;
}
.icon-service-order {
  background-image:  url("~assets/service-request/menu/service_order.png");
  width: 32px; height: 32px;
  background-size: 100%;
  margin-left: 10px;
}
.icon-service {
  background-image:  url("../../../../assets/service-request/menu/service.png");
  width: 32px; height: 32px;
  background-size: 100%;
  margin-left: 10px;
}
.q-item{
  min-height: 28px;
}
.text-main-menu {
  @apply tw-m-0 tw-text-lg;
}
</style>
